import { Tabs } from '@mantine/core';
import { ProfileUser } from '../ProfileUser';
import { VipAchievements } from './VipAchievements';
import { VipCharacterCard } from './VipCharacterCard';
import { VipRewardsRank } from './VipRewardsRank';
export const Vip: React.FC = () => {
  return <Tabs.Panel value="vip">
      <ProfileUser />
      <VipAchievements />
      <VipCharacterCard />
      <VipRewardsRank />
    </Tabs.Panel>;
};